// extracted by mini-css-extract-plugin
module.exports = {"container":"mg","block":"ng","subheading":"og","cta":"pg","disabled":"qg","noBotMargin":"rg","light":"sg"};